import "./mobileEventCard.css";
import React from "react";
import { FaUserCheck } from "react-icons/fa";
import { dots } from "../../assets";
import helperService from "../../services/helper.service";

function MobileEventCard({ event, currentMode, handleViewEvent }) {
	return (
		<>
			<div
				className={`event_card ${event?.status} ${currentMode}`}
				onClick={() => handleViewEvent(event)}
			>
				<div className="event_card_header">
					<div className="event_card_header_for_event">
						<h3>{event?.title}</h3>
					</div>
					<div className="event_card_header_for_more">
						<img src={dots} alt="dots" />
					</div>
				</div>
				<div className="event_card_body">
					<p>{event?.otherDetails || "..."}</p>
				</div>
				<div className="event_card_footer">
					<div className="event_card_header_for_icon_and_participants">
						<FaUserCheck
							className={`event_card_participate_icon ${event?.status}`}
						/>
						<p>
							<span>{event?.participantsCount}</span>{" "}
							{event?.participantsCount > 1 ? "Participants" : "Participant"}
						</p>
						<span className={`event_mode_pill ${event?.eventMode}`}>
							{helperService.capitalize(event?.eventMode)}
						</span>
					</div>
				</div>
			</div>
		</>
	);
}

export default MobileEventCard;
